import React, { useState } from "react";
// import { TbArrowsJoin2 } from "react-icons/tb";
import axiosInstance from "../../Axois/Axois";
import toast, { Toaster } from "react-hot-toast";
import { Link } from "react-router-dom";
const SectionTwo = () => {
  const [formData, setFormData] = useState({
    name: "",
    address: "",
    communityBackground: "",
    email: "",
    mobilePhone: "",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    console.log(formData, 'data')
    try {
      const { name, address, communityBackground, email, mobilePhone } =
        formData;
      const Datatosend = new FormData();
      Datatosend.append("name", name);
      Datatosend.append("email", email);
      Datatosend.append("phone", mobilePhone);
      Datatosend.append("address", address);
      Datatosend.append("community_background", communityBackground);
      axiosInstance
        .post("/csp-request", Datatosend)
        .then((res) => {
          console.log(res, "check");

          if (res.data.status === true) {
            toast.success(res.data.message);
            setFormData({
              name: "",
              address: "",
              communityBackground: "",
              email: "",
              mobilePhone: "",
            })
          }
        })
        .catch((err) => {
          toast.error(err.message);
        });
    } catch (error) {
      console.log(error, "formData");
    }
  };

  return (
    <div className="container mt-40">
      <Toaster position="top-right" reverseOrder={false} />
      <div className="row mt-40">
        <div className="col-12 text-center">
          <h1 className="fw-bold">Fill the form to join as a <span className="cspSpan">(CSP)</span></h1>
          <p>Join to help your community</p>
        </div>
        <Link to={"/login"}>
          {/* <div className="row justify-content-center gap-3 mb-4">
          <button className="col-lg-2 col-md-4 col-5 btn btn-warning registerBtn text-light">
            Register
          </button>
        </div> */}
        </Link>
      </div>
      <div className="row">
        <div className="col-lg-6 col-md-12 col-12">
          <p className="cspP">
            How  To apply to be a CSP, you need to Register.
          </p>
          <p>
            When we receive that, one of our team will send you a more detailed form and contact you to
            discuss your application, the process, responsibilities and benefits.
          </p>
          <p>
            This process ensures you meet Share-Circle (SC) criteria for becoming a community lending
            Partner.
          </p>
          <p>
            If you do not meet these criteria initially, we may provide some recommendations or guidance to
            enable you to become a CSP.
          </p>
          <p>
            Once accepted, we will work with you, through the process of registering your entrepreneurs for
            supported crowdfunded loans.
          </p>
          <p>
            We hope that together we can support you to grow and help your community.
          </p>
        </div>

        <div className="col-lg-6 col-md-12 col-12 py-3">
          <h4 className="text-center mb-4 fw-bold"> Become a Community Partner</h4>
          <div className="form1232">
            <form onSubmit={handleSubmit}>
              <div>
                {/* <label>Name:</label> */}
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                  required
                  className="p-3 rounded-3"
                  placeholder="Name"
                />
              </div>
              <div>
                {/* <label>Address:</label> */}
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleInputChange}
                  required
                  className="p-3 rounded-3"
                  placeholder="Address"
                />
              </div>
              <div>
                {/* <label>Community background (Detailed please)</label> */}
                <input
                  type="text"
                  name="communityBackground"
                  value={formData.communityBackground}
                  onChange={handleInputChange}
                  required
                  className="p-3 rounded-3"
                  placeholder="Community background (Detailed please)"
                />
              </div>
              <div>
                {/* <label>Email Address:</label> */}
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                  className="p-3 rounded-3"
                  placeholder="Email Address"
                />
              </div>
              <div>
                {/* <label>Mobile Phone:</label> */}
                <input
                  type="tel"
                  name="mobilePhone"
                  value={formData.mobilePhone}
                  onChange={handleInputChange}
                  required
                  className="p-3 rounded-3"
                  placeholder="Mobile Phone"
                />
              </div>
              <button
                style={{
                  backgroundColor: "#ffa500",
                  fontSize: "16px",
                  fontWeight: "600",
                  textAlign: "center"
                }}
                type="submit"
              >
                Submit &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span className="arrow-icon"><img src="../images/icon.png" alt="" /></span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionTwo;
